import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {SharedModule} from 'src/app/shared/shared.module';
import {TenantLayoutComponent} from './tenant-layout.component';
import {RouterModule} from '@angular/router';
import {TenantLayoutRoutingModule} from './tenant-layout-routing.module';
import {HeaderModule} from './header/header.module';
import {FooterModule} from './footer/footer.module';
import { MatSidenavModule } from '@angular/material/sidenav';
import { TenantMenuComponent } from './tenant-menu/tenant-menu.component';
import { MatListModule } from '@angular/material/list';
import { PathToLiveWorkflowModule } from '../main/service/path-to-live-workflow/path-to-live-workflow-module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
  declarations: [
    TenantLayoutComponent,
    TenantMenuComponent
  ],
  imports: [
    TenantLayoutRoutingModule,
    CommonModule,
    SharedModule,
    HeaderModule,
    FooterModule,
    RouterModule,
    MatSidenavModule,
    MatListModule,
    PathToLiveWorkflowModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatProgressBarModule
  ]
})
export class TenantLayoutModule { }
